import React from "react";
// import FormProgress from '../UnitAdmin/FormProgress';
import FormProgress from "../AuditAdmin/FormProgress";
import SendBackFullScopeAccordion from "./SendBackFullScopeAccordion";

const SendBackFullScope = ({version}) => {
  return (
    <>
      <div className="addendum-main-container">
        <FormProgress />
        <div className="addendum-heading">Mars QMS - QMS Full Scope</div>
        <SendBackFullScopeAccordion version={version}/>
      </div>
    </>
  );
};

export default SendBackFullScope;
